import API from '../api/temporary';
import { ApiRoutes } from '../constans/api';

export enum EScore {
  HIGH = 'high',
  NORMAL = 'normal',
  LOW = 'low',
}

export enum EScoreRating {
  STRONG = 'strong',
  NORMAL = 'normal',
  WEAK = 'weak',
}

export enum EPRMCode {
  'S1' = 'S1',
  'S2' = 'S2',
  'S3' = 'S3',
  'S4' = 'S4',
  'S5' = 'S5',
}

export interface IGroupDistribution {
  normal_percentage: number;
  strong_percentage: number;
  weak_percentage: number;
}

export interface IWorkEnvironmentCategory {
  code: string;
  description: string;
  title: string;
  topics: string[];
}

export interface IWorkEnvironmentCategoryData {
  category: IWorkEnvironmentCategory;
  group_distribution: IGroupDistribution;
  score: EScore;
  score_rating: EScoreRating;
}

export interface IIndividualStatesTopic {
  code: string;
  description: string;
  exampleStatement: string;
  title: string;
}

export interface IIndividualStatesTopicsData {
  group_distribution: IGroupDistribution;
  score: EScore;
  score_rating: EScoreRating;
  topic: IIndividualStatesTopic;
}

export interface IIndividualStates {
  description: string;
  group_description: string;
  topics: IIndividualStatesTopicsData[];
}

export interface IWorkEnvironmentData {
  description: string;
  group_description: string;
  categories: IWorkEnvironmentCategoryData[];
}

export interface IIndividualReportData {
  introduction: string;
  work_environment: IWorkEnvironmentData;
  individual_states: IIndividualStates;
  key_takeaways: string;
  prm_code: EPRMCode | null;
}

export interface IGetIndividualReport200Resp {
  data: IIndividualReportData | null;
  message?: string;
  respondent: string;
  survey: string;
}

export interface IGetIndividualReportError {
  details: string;
  status: number;
  title: string;
}

export const getIndividualReportRequest = async (slug: string) => {
  const { individualReports } = ApiRoutes;
  const { data } = await API.get<IGetIndividualReport200Resp>(`${individualReports}${slug}/`);

  return data;
};
